var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextTrack = function SvgTextTrack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    viewBox: "0 0 1200 1200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M312 372h144v456h-96v72h264v-72h-96V372h144v72h72V336a36.01 36.01 0 0 0-10.543-25.457A36.01 36.01 0 0 0 708 300H276a36.01 36.01 0 0 0-25.457 10.543A36.01 36.01 0 0 0 240 336v108h72z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M648 636h120v264h72V636h120v-72H648z"
  })));
};
export default SvgTextTrack;